import React from 'react';

import {
  animationDelays,
  spinnerGrid,
  spinnerSquare,
} from '#Client/components/Spinner/Spinner.css';

export const Spinner = () => (
  <div className={spinnerGrid}>
    <div className={`${spinnerSquare} ${animationDelays[1]}`}></div>
    <div className={`${spinnerSquare} ${animationDelays[2]}`}></div>
    <div className={`${spinnerSquare} ${animationDelays[3]}`}></div>
    <div className={`${spinnerSquare} ${animationDelays[4]}`}></div>
    <div className={`${spinnerSquare} ${animationDelays[5]}`}></div>
    <div className={`${spinnerSquare} ${animationDelays[6]}`}></div>
    <div className={`${spinnerSquare} ${animationDelays[7]}`}></div>
    <div className={`${spinnerSquare} ${animationDelays[8]}`}></div>
    <div className={`${spinnerSquare} ${animationDelays[9]}`}></div>
  </div>
);
